import React, { useState,useEffect } from 'react';
import axios from 'axios'
import CommonVars from '../Component/CommonVars';
import {
    Flex,
    Box,
    Image,
    Heading,
    VStack,
    Button,
    Link
  } from '@chakra-ui/react';

function OrderScreen () {
    const [orders, setOrdersData] = useState([]);
    const orderToken = localStorage.getItem('token');

    if(orderToken == null){
        window.location.replace('/login');
    }

    useEffect(() => {
        getAllOrders();
    }, [])

    const getAllOrders = async() => {
        axios.get(`${CommonVars.API_URL}/orders`, 
            { headers: { Authorization: `Bearer ${orderToken}` } } 
        )
            .then((res) => {
                console.log(res);
                setOrdersData(res.data);
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const userid = localStorage.getItem('loggedInUserID');

    const orderArr = [];

    for(var i = 0; i < orders.length; i++)
    {
        orderArr.push(
            <Box
                key={i}
                margin={'1'} 
                boxShadow={'dark-lg'} 
                w={'850px'} 
                bg={'white'}
            >
                <Flex>
                    {/* <Box>
                        <Image boxSize={'150'} src={orders[i].image}/>
                    </Box> */}
                    <Box marginRight={'5'}>
                        <VStack >
                            <Flex>
                                <Box marginInlineStart={'3'} fontWeight={'semibold'}>
                                User: 
                                </Box>
                                <Box fontWeight={'semibold'} marginInline={'5'}>
                                {orders[i].username}
                                </Box>
                            </Flex>
                            <Box marginTop={'5'} fontWeight={'semibold'} fontSize={'2xl'}>
                                {orders[i].name}
                            </Box>
                            <Flex>
                                <Box marginInlineStart={'3'} fontWeight={'semibold'}>
                                Total: 
                                </Box>
                                <Box  fontWeight={'semibold'} marginInline={'5'}>
                                ${orders[i].total}
                                </Box>
                            </Flex>
                        </VStack>

                    </Box>
                    <Box marginInlineStart={'80'} marginTop={'30'}>
                        <Button   bg={'gray.100'}>
                            <Link href={`/orders/${orders[i].orderid}/user/${userid}`}>
                            View Order Detail
                            </Link>
                        </Button>              
                    </Box>             
                </Flex>
            </Box>
        )
    }

    return (
        <Box>
            <Heading>Order Screen</Heading>
            <Box  marginY={'250'} marginInline={'300'}>{orderArr}</Box>
        </Box>
    )
}

export default OrderScreen;